export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImZhOTFkOWZmLTQxYzYtNGExNS05NjNiLTQyYjhlMzJlMzU4MyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.JYZqKh4lqdBQewVGe+/OkeCTBKhQ7wqHCOgwfH2eXLdZhpOSJqYp1Rd2IPrerYTY/61YkyIfPGVZ26o5wbLjo5fHP6JrJwLixvuf5IRfqw5Lz5DySsjGCGYHpZ/nN8cwXM6gMQ=='
